import {importFile, MainRequest, UserListItem} from 'Services/common';
import {download, makeDict} from 'Utils/common';

export enum Gender {
    Male = '1',
    FeMale = '2',
}

export const GenderDict = makeDict([
    {label: '男', value: Gender.Male},
    {label: '女', value: Gender.FeMale},
]);

export enum UserStatus {
    Freeze = '0', // 冻结
    Normal = '1', // 正常
}

export const UserStatusDict = makeDict([
    {label: '已冻结', value: UserStatus.Freeze},
    {label: '正常', value: UserStatus.Normal},
]);

export interface QueryUserList {
    userName?: string;
    gender?: string;
}

/**
 * 用户列表(分页)
 */
export function getUserListPage(query: QueryUserList, pagination: Pagination) {
    return MainRequest.post<PagedSuccessData<UserListItem[]>>('/user/page', {
        ...pagination,
        ...query,
    }).then(res => res.data.data);
}

export interface UserFormData {
    id?: string;
    code: string; // 用户账号
    userName: string; // 用户姓名
    roleId?: string[];
    defaultRoleId?: string; // 默认角色id
    photo?: string; // 头像七牛url
    gender: Gender; // 1男2女
    email?: string; // 邮箱
    phone?: string; // 电话
    tel?: string; // 座机
}

/**
 * 新增/编辑用户
 * @param data
 */
export function saveUser(data: UserFormData) {
    return MainRequest.post('/user/save', data);
}

export interface UserDetail {
    id: string;
    code: string;
    createTime: Date;
    defaultRoleId: string;
    email: string;
    gender: Gender;
    loginName: string;
    phone: string;
    photo: string;
    roleId: string[];
    status: string;
    tel: string;
    userName: string;
}

/**
 * 用户获取详情
 * @param id
 */
export function getUserDetail(id: string) {
    return MainRequest.post<SuccessData<UserDetail>>('/user/detail', {id}).then(
        res => res.data.data,
    );
}

/**
 * 用户冻结/恢复
 * @param id
 * @param status
 */
export function changeUserStatus(id: string, status: UserStatus) {
    return MainRequest.post('/user/changeStatus', {id, status});
}

/**
 * 删除用户
 * @param id
 */
export function deleteUser(id: string) {
    return MainRequest.post('/user/delete', {id});
}

/**
 * 重置密码
 * @param id
 */
export function resetUserPwd(id: string) {
    return MainRequest.post('/user/resetPwd', {id});
}

/**
 * 用户excel导入
 * @param file
 */
export function importUserExcel(file: File) {
    return importFile('/user/importExcel', file);
}

/**
 * 导出用户
 */
export function exportUserExcel() {
    return download('/user/exportExcel', {method: 'POST'});
}
